import React from 'react'

function ExternalLink({ to, text, className }) {
  return (<a className={className} href={to} rel='noreferrer' target='_blank'>{text}</a>)
}

export default ExternalLink